import "/Users/mpagalan/Projects/ormoc-ctzn-form-google/node_modules/core-js/modules/es.array.iterator.js";
import "/Users/mpagalan/Projects/ormoc-ctzn-form-google/node_modules/core-js/modules/es.promise.js";
import "/Users/mpagalan/Projects/ormoc-ctzn-form-google/node_modules/core-js/modules/es.object.assign.js";
import "/Users/mpagalan/Projects/ormoc-ctzn-form-google/node_modules/core-js/modules/es.promise.finally.js";
import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import vuetify from "./plugins/vuetify";
import firebase from "firebase/app";
import "./registerServiceWorker";
Vue.config.productionTip = false;
var app;
firebase.auth().onAuthStateChanged(function (user) {
  if (!app) {
    app = new Vue({
      router: router,
      vuetify: vuetify,
      render: function render(h) {
        return h(App);
      },
      data: function data() {
        return {
          user: user
        };
      }
    }).$mount("#app");
  } else {
    app.user = user;
  }
});